import type { StrapiFaq } from '~/composables/types/strapi/common'
import { parseFaqAnswer } from '~/utils/faqMarkdown'

type FormatContent = (content: string | null) => string | undefined

/**
 * Prepares a magazine article FAQ for rendering: replaces dynamic placeholders
 * in questions and answers, and parses answers as markdown (same parser as the
 * article body) so links etc. render as HTML instead of raw markdown.
 * Questions stay plain text — they render inside the `<summary>` toggle.
 */
export const formatMagazineFaq = (
  faq: StrapiFaq | null | undefined,
  formatContent: FormatContent
): StrapiFaq | undefined => {
  if (!faq) return

  return {
    ...faq,
    questions: faq.questions?.map((item) => {
      return {
        ...item,
        question: formatContent(item.question),
        answer: parseFaqAnswer(formatContent(item.answer)),
      }
    }),
  }
}
